define('plugins/musicfavourite/ui/dialogs/dialog',['../dom','./text','../../env','../../events'],
    function(DOM, localisationString, env, PubSub) {
        var GUTTER_MARGIN_PX = 16;
        var instance = null;
        var dialogTriggerButton;
        var dialogElement;

        var Dialog = function() {
            var self = this;

            self.lang = 'en-gb'; // Need to make lang global but for the moment I'm hard coding it, get over it!

            if (instance !== null) {
                throw new Error('Cannot instantiate more than one Dialog, use Dialog.getInstance()');
            }

            self.initialize();

            // Public functions
            return {
                'setContent':function(h, callback) {
                    self.setContent(h);
                    if (callback) callback();
                },

                'show':function(triggerButton, callback) {
                    dialogTriggerButton = triggerButton;

                    self.show();
                    if (callback) callback();
                },

                'showAsTooltip':function(triggerButton, callback) {
                    dialogTriggerButton = triggerButton;

                    self.showAsTooltip();
                    if (callback) callback();
                },

                'hide':function(callback) {
                    self.hide();
                    if (callback) callback();
                },
                'subscribe': function(name, f) {
                    self.subscribe(name, f);
                },
                'getLocalisedString':function(key, lang) {
                    return self.getLocalisedString(key, lang);
                },
                'classes':Dialog.classes
            };
        };

        Dialog.prototype = {
            initialize: function() {
                var self = this;

                self.subscribe('visible', function() {
                    Dialog.flash.hideAll();
                });

                self.subscribe('hidden', function() {
                    Dialog.flash.showAll();
                });

                self.setWrapper();
                self.bindEvents();
            },

            /**
             * Retrieve a localised string based on a translation key and category.
             *
             * @param  {string} key      Key for translation text.
             * @param  {string} lang     Language for lookup, defaults to "en-gb".
             * @return {string}          Translated text for key.
             */
            'getLocalisedString': function(key, lang) {
                var translatedKeys;

                if (!lang || !localisationString[lang]) {
                    lang = 'en-gb'; // default
                }
                translatedKeys = localisationString[lang];

                key = key || '';

                if (translatedKeys[key]) {
                    return translatedKeys[key];
                }

                return lang !== 'en-gb' && getLocalisedString(key, 'en-gb') || key;
            },

            'setWrapper': function() {
                var h = [
                    '<div class="', Dialog.classes.overlay, '">', '</div>',
                    '<div class="', Dialog.classes.wrapper, '">',
                        '<div class="', Dialog.classes['triangle'], '"></div>',
                        '<div class="', Dialog.classes['wrapper-inner'], ' ', Dialog.classes['clearfix'], '" tabindex="1">',
                            '<button class="', Dialog.classes.close, '">', '<i class="', Dialog.classes['close-icon'] ,'">', '<span class="', Dialog.classes.hidden ,'">', this.getLocalisedString('close', this.lang), '</span>', '</button>',
                            '<div class="', Dialog.classes.content, '">',
                                '<div class="', Dialog.classes['content-inner'], '">','</div>',
                            '</div>',
                        '</div>',
                    '</div>'
                ].join('');

                if (!DOM.findElement('.' + Dialog.classes.wrapper).length) DOM.append(DOM.findElement('body'), h);
                dialogElement = DOM.findElement('.' + Dialog.classes.wrapper);

                this.hide();
            },

            'bindEvents': function() {
                var self = this,
                    clicked;

                DOM.on(DOM.findElement('.' + Dialog.classes.close)[0], 'click', function(e) {
                    e.stop();
                    self.hide(clicked = true);
                });

                DOM.on(DOM.findElement('.' + Dialog.classes.overlay)[0], 'click', function(e) {
                    e.stop();
                    self.hide(clicked = true);
                });

                DOM.on(document, 'keydown', function(e) {
                    if (e.keyCode == 27) {
                        e.stop();
                        self.hide(clicked = false);
                    }
                });
            },

            'center': function() {
                var dialogOffset = DOM.offset(dialogElement);
                DOM.css(dialogElement, {
                    'margin-left':'-' + (dialogOffset.width / 2) + 'px',
                    'margin-top':'-' + (dialogOffset.height / 2) + 'px',
                    'z-index':'9999'
                });
            },

            'setContent': function(h) {
                DOM.setHTML(DOM.findElement('.' + Dialog.classes['content-inner']), h);
            },

            'removeContent': function() {
                DOM.empty(DOM.findElement('.' + Dialog.classes['content-inner']));
            },

            'show': function() {
                DOM.show(DOM.findElement('.' + Dialog.classes.overlay));
                DOM.show(dialogElement);

                this.setupResizeHandler();

                this.center();
                this.focus();

                this.publish('visible', this);

                //bind manage link if necessary

                var self = this;

                if (DOM.findElement('.' + Dialog.classes.manageLink).length > 0) {
                    DOM.on(DOM.findElement('.' + Dialog.classes.manageLink)[0], 'click', function(e) {
                        self.hide(true);
                    });
                }
            },

            'showAsTooltip': function() {
                if (DOM.isHidden(dialogElement)) {
                    DOM.addClass(dialogElement, Dialog.classes.tooltip);
                    this.show();
                }
                this.positionAsTooltip();
            },

            'hide': function(click) {
                DOM.setAttr(dialogElement, 'style', '');
                DOM.removeClass(dialogElement, Dialog.classes.tooltip);

                DOM.hide(DOM.findElement('.' + Dialog.classes.overlay));
                DOM.hide(dialogElement);

                this.cleanupResizeHandler();

                this.removeContent();

                this.blur(click);

                this.publish('hidden', this);
            },

            'resizeHandler': function() {
                // 'this' in an event handler is the DOM element receiving the event so we can't use it
                Dialog.getInstance().hide();
            },

            'setupResizeHandler': function() {
                DOM.on(window, 'resize', this.resizeHandler);
            },

            'cleanupResizeHandler': function() {
                DOM.off(window, 'resize', this.resizeHandler);
            },

            'focus': function() {
                setTimeout(function() {
                    DOM.focus(DOM.findElement('.' + Dialog.classes['wrapper-inner'])[0]);
                    DOM.addClass(dialogElement, Dialog.classes.focus);
                }, 200);
            },

            'blur': function(isClicked) {
                DOM.blur(DOM.findElement('.' + Dialog.classes.close));
                DOM.removeClass(DOM.findElement('.' + Dialog.classes.close), Dialog.classes.focus);
                if (!isClicked && dialogTriggerButton) {
                    DOM.focus(dialogTriggerButton);
                }
            },

            'positionAsTooltip': function() {
                var TRIANGLE_LEFT_OFFSET_PX = 22;
                var TRIANGLE_HALF_WIDTH_PX = 12; // Should be consistent with border-left width in CSS

                var button = dialogTriggerButton;
                var viewport = DOM.findElement('body')[0].getBoundingClientRect();
                var buttonPosition = button.getBoundingClientRect();
                var buttonPositionLeft = buttonPosition.left + window.pageXOffset;
                var buttonPositionBottom = buttonPosition.bottom + window.pageYOffset;
                var tooltipWidth = DOM.offset(dialogElement).width;
                var tooltipHeight = DOM.offset(dialogElement).height;

                var tooltipLeft;
                if (tooltipWidth + 2 * GUTTER_MARGIN_PX >= viewport.width) {
                    // Centre the tooltip - note that the actual gutter margin may be smaller than GUTTER_MARGIN_PX
                    tooltipLeft = (viewport.width - tooltipWidth) / 2;
                } else {
                    // Left-align the tooltip with the button, checking whether it goes out of the page to the right
                    tooltipLeft = (buttonPositionLeft + tooltipWidth + GUTTER_MARGIN_PX < viewport.width)
                        ? buttonPositionLeft
                        : viewport.width - (tooltipWidth + GUTTER_MARGIN_PX);
                }

                var tooltipTriangleElement = DOM.findElement('.' + Dialog.classes['triangle'])[0];
                DOM.css(tooltipTriangleElement, {
                    'margin-left': buttonPositionLeft + TRIANGLE_LEFT_OFFSET_PX - TRIANGLE_HALF_WIDTH_PX - tooltipLeft
                });

                DOM.css(dialogElement, {
                    'left': tooltipLeft,
                    'top': buttonPositionBottom,
                    'margin-top': 0,
                    'margin-left': 0
                });

                if (buttonPosition.bottom + tooltipHeight > window.innerHeight) {
                    var bottom = buttonPositionBottom + tooltipHeight + GUTTER_MARGIN_PX;
                    scrollTo(0, bottom - window.innerHeight);
                }
            }
        };

        Dialog.flash = {
            'hide':function(el) {
                DOM.css(el, {
                    'visibility':'hidden'
                });
            },
            'show':function(el) {
                DOM.css(el, {
                    'visibility':'visible'
                });
            },
            'hideAll':function() {
                var elems = DOM.findElement('object, embed'),
                    el, i = 0;

                for (i; (el = elems[i]); i++) {
                    this.hide(el);
                }
            },
            'showAll':function() {
                var elems = DOM.findElement('object, embed'),
                    el, i = 0;

                for (i; (el = elems[i]); i++) {
                    this.show(el);
                }
            }
        };

        Dialog.classes = {
            'overlay'       : 'p-f-dialog-overlay',
            'wrapper'       : 'p-f-dialog-wrapper',
            'wrapper-inner' : 'p-f-dialog-wrapper-inner',
            'content'       : 'p-f-dialog-content',
            'content-inner' : 'p-f-dialog-content-inner',
            'heading'       : 'p-f-dialog-heading',
            'text'          : 'p-f-dialog-text',
            'close'         : 'p-f-dialog-close',
            'focus'         : 'p-f-dialog-focus',
            'hidden'        : 'p-f-hidden',
            'manageLink'    : 'p-f-manage-link',
            'tooltip'       : 'p-f-tooltip',
            'triangle'      : 'p-f-triangle',
            'close-icon'    : 'gelicon gelicon--no',
            'clearfix'      : 'clearfix'
        };

        Dialog.getInstance = function() {
            if (instance === null) {
                instance = new Dialog();
            }

            return instance;
        };

        PubSub.context('dialog', Dialog);

        return Dialog.getInstance();
});
